import { useState } from "react"

interface Props {
	img: string
	views: string
	channel: string
	link: string
}

export default function ScrollerItem({ img, views, channel, link }: Props) {
	const [isHovered, setIsHovered] = useState(false)

	return (
		<a
			href={link}
			target="_blank"
			className="relative"
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<div className="w-40 md:w-56 lg:w-80 2xl:w-[15vw] h-full">
				<div className="relative">
					<img
						src={img}
						width={320}
						height={569}
						loading="lazy"
						decoding="async"
						className={`h-64 w-full object-cover md:h-[380px] lg:h-[60vh] lg:min-h-[500px] transition-all duration-200 ${
							isHovered ? "brightness-[0.6]" : ""
						}`}
						alt={`${channel} video thumbnail`}
					/>
					{/* Gradient Overlay */}
					<div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/90 to-transparent sm:p-6 p-3 md:p-4 flex flex-col gap-1 md:gap-2 h-1/2 justify-end">
						<h1 className="2xl:text-4xl xl:text-4xl lg:text-4xl text-xl md:text-3xl poppins-bold font-medium text-white sm:w-full w-3/4">
							{views}
						</h1>
						<h2 className="text-sm md:text-md lg:text-lg text-white">{channel}</h2>
					</div>
				</div>
			</div>

			{/* Hover Div */}
			{isHovered && (
				<div className="absolute sm:top-6 sm:right-6 top-4 right-4 flex items-center justify-center text-white text-lg font-semibold transition-opacity mb-0">
					<svg
						className="fill-white w-10 h-10 md:w-12 md:h-12"
						version="1.1"
						viewBox="0 0 1200 1200"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="m400 350c0-27.613 22.387-50 50-50h400c27.613 0 50 22.387 50 50v400c0 27.613-22.387 50-50 50s-50-22.387-50-50v-279.29l-414.64 414.64c-19.527 19.523-51.184 19.523-70.711 0-19.527-19.527-19.527-51.184 0-70.711l414.64-414.64h-279.29c-27.613 0-50-22.387-50-50z" />
					</svg>
				</div>
			)}
		</a>
	)
}
